import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'post'

export default class OspreyOffersTagsApply extends BaseAction {
    constructor(dataKey) {
        const id = 'abc42651-f282-40eb-8b95-1930fe1ade1d'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    applyTagToOffer(params) {
        const { offerId, tagIdList } = params

        this.path = `/${resource}/${offerId}/tags`

        this.params = {
            tagIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-tags-apply.js